import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Select, Button, Row, Col } from 'antd';
import PagesHeader from '../../components/PageHeader';
import InspectionRequestData from '../../datatables/inspectionDataTable';
import * as InspectionServices from '../../services/createManualrequest';
import { useDispatch, useSelector } from 'react-redux';
import ButtonBar from '../../components/ButtonNavigation';
import {
  PlusOutlined,
} from "@ant-design/icons";

const { Option } = Select;

const InspectionRequest = (props) => {
  var dispatch = useDispatch();
  const [loadings, setLoadings] = useState([]);
  const [modalInspection, setModalInspection] = useState(false);
  const [value, setValue] = useState();
  const [isActiveKey, setActiveKey] = useState('5');
  const userDetails = useSelector((state) => state.User.userDetails);
  const isLimitedAccess = userDetails?.limited_access;
  const [currentUser, setCurrentUser] = useState({});
  let navigate = useNavigate();

  useEffect(() => {
    setCurrentUser(userDetails);
  }, [userDetails]);

  console.warn("Current User", currentUser);

  const handleChange = (newValue) => {
    setValue(newValue);
    console.log('Hello', newValue);
  };


  const handleClick = () => {
    setModalInspection(true);
  };

  const enterLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 6000);
  };

// Route mapping configuration - easy to maintain and extend
const CATEGORY_ROUTE_MAP = {
  "Quick Report": "quick-report-update",
  "Carpet -Basic": "carpet-basic-update",
  "Carpet": "carpet-detailed-update",
  "Hard Surface -Basic": "hardwood-basic-update",
  "Hardwood": "hardwood-detailed-update",
  "LVT": "lvt-update",
  "Tile": "tile-report-update",
  "Laminate": "laminate-update",
  "NWFA Sand Finish": "update-nwfa-sand-finish-report",
  "NWFA Installation": "update-nwfa-installation-report"
};

const handleSubmit = async (e, index) => {
  e.preventDefault();
  
  if (!value) {
    return;
  }

  try {
    enterLoading(0);
    
    const dropDownval = {
      floor_category: value
    };
    
    const res = await dispatch(InspectionServices.createManualreq(dropDownval));
    
    const navTo = getCategoryRoute(value, res);
    
    if (navTo) {
      localStorage.removeItem("reportDrafts");
      navigate(`/${navTo}`);
    } else {
      console.error(`Unknown category: ${value}`);
      // Handle unknown category case - maybe show error to user
    }
  } catch (error) {
    console.error("Error creating manual request:", error);
    // Handle error - show error message to user
  } finally {
    enterLoading(0);
  }
};

const getCategoryRoute = (value, res) => {
  const baseRoute = CATEGORY_ROUTE_MAP[value];
  
  if (!baseRoute) {
    return null;
  }
  
  // Routes that don't need report_id parameter
  // const standaloneRoutes = ["nwfa-sand-finish-inspection-report", "nwfa-installation-inspection-report"];
  
  // if (standaloneRoutes.includes(baseRoute)) {
  //   return baseRoute;
  // }
  
  return `${baseRoute}/?report_id=${res.report_id}`;
};

  const options = [
    {
      id: 1,
      value: "Quick Report",
      label: "Quick Report",
    },
    {
      id: 2,
      value: "Carpet -Basic",
      label: "Carpet -Basic",
    },
    {
      id: 3,
      value: "Carpet",
      label: "Carpet -Detailed",
    },
    {
      id: 4,
      value: "Hard Surface -Basic",
      label: "Hardwood -Basic",
    },
    {
      id: 5,
      value: "Hardwood",
      label: "Hardwood -Detailed",
    },
    {
      id: 6,
      value: "LVT",
      label: "LVT",
    },
    {
      id: 7,
      value: "Tile",
      label: "Tile",
    },
    {
      id: 8,
      value: "Laminate",
      label: "Laminate",
    }
  ];

  const optionsNwfa = [
    {
      id: 1,
      value: "Quick Report",
      label: "Quick Report",
    },
    {
      id: 2,
      value: "Carpet -Basic",
      label: "Carpet -Basic",
    },
    {
      id: 3,
      value: "Carpet",
      label: "Carpet -Detailed",
    },
    {
      id: 4,
      value: "Hard Surface -Basic",
      label: "Hardwood -Basic",
    },
    {
      id: 5,
      value: "Hardwood",
      label: "Hardwood -Detailed",
    },
    {
      id: 6,
      value: "LVT",
      label: "LVT",
    },
    {
      id: 7,
      value: "Tile",
      label: "Tile",
    },
    {
      id: 8,
      value: "Laminate",
      label: "Laminate",
    },
    {
      id: 9,
      value: "NWFA Sand Finish",
      label: "NWFA Sand Finish",
    },
    {
      id: 10,
      value: "NWFA Installation",
      label: "NWFA Installation",
    },
  ];

  console.info(setActiveKey);

  return (
    <div className="inspectionWrapper">
      <div className="inspectionHeader">
        <PagesHeader
          title='Completed Reports'
        />
      </div>
      <div className='buttonSection'>
        <div className="container-xxl">
          <Row>
            <Col xs={24} md={18} className="text-end">
              <ButtonBar />
            </Col>
            <Col xs={24} md={6}>
              <Button
                type='success'
                className="btn inspectionAdd"
                onClick={() => handleClick()}
                icon={<PlusOutlined />}
                disabled={isLimitedAccess}
              >
                New Inspection
              </Button>
            </Col>
          </Row>
        </div>
      </div>
      <div className="inspectionWrapInner">
        <div className="container-xxl">
          <InspectionRequestData activeKey={isActiveKey} />
        </div>
      </div>

      {/* Inspection Modal */}
      <Modal
        title="Floor Category"

        open={modalInspection}
        onCancel={() => setModalInspection(false)}
        className="inspectionCategoryModal"
        footer={[
          <Button
            key="submit"
            htmlType="submit"
            className="submitBtn"
            onClick={handleSubmit}
            loading={loadings[0]}
          >
            Submit
          </Button>,
        ]}
      >
        <div className="modalContent">
          <div className="formGroup">
            {userDetails?.nwfa_certified === '1' ? (
              <Select
                placeholder="Select Floor Category"
                onChange={handleChange}
                value={value}
              >
                {optionsNwfa.map((option) => (
                  <Option value={option.value}>{option.label}</Option>
                ))}
              </Select>
            ) : (
              <Select
                placeholder="Select Floor Category"
                onChange={handleChange}
                value={value}
              >
                {options.map((option) => (
                  <Option value={option.value}>{option.label}</Option>
                ))}
              </Select>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default InspectionRequest;
